import { sendToNative } from 'app/webview/utils'

export const showPlusUpsell = () => {
  sendToNative({
    id: 'show-sub-upsell',
    payload: {
      type: 'deep_link',
      body: {
        url: `https://fable.co/app/fablefriends_goals`,
      },
    },
  })
}
